import React from 'react'
import HTMLFlipBook from "react-pageflip";
import {Link} from 'react-router-dom';

export default function FlipbookCats() {
    const catImages = Array.from({ length: 40 }, (_, i) => i + 1);
  return (
    <div className='d-flex justify-content-center page-content-flipbook'>
      <HTMLFlipBook width={350} height={550} showCover={true}>
            <div className="page flipbook-cover">
              <h1 className='pt-4'>My Cat Flipbook</h1>
              <div className='d-flex justify-content-center pt-5 pb-3'>
                <div className='flipbook-cover-image-grid'>
                  <div style={{backgroundColor:"White"}}><img height={100} width={100} src='./images/flipbook/cats/cat-cover005.jpg' alt='dog001'/></div>
                  <div style={{backgroundColor:"White"}}><img height={100} width={100} src='./images/flipbook/cats/cat-cover002.jpg' alt='dog001'/></div>
                  <div style={{backgroundColor:"White"}}><img height={100} width={100} src='./images/flipbook/cats/cat-cover003.jpg' alt='dog001'/></div>
                  <div style={{backgroundColor:"White"}}><img height={100} width={100} src='./images/flipbook/cats/cat-cover004.jpg' alt='dog001'/></div>
                </div>
              </div>
              <p className='pt-3'>A cute cat photo collection</p>
            </div>

            {catImages.map((num, index) => (
            <div className="page" key={num}>
              <div className='d-flex justify-content-center'>
                <img className='flipbook-image' height={500} width={300} src={`./images/flipbook/cats/cat${String(num).padStart(3, "0")}.jpg`} alt={`dog${String(num).padStart(3, "0")}`}/>
              </div>
                <div className='d-flex justify-content-left ms-1' style={{ marginTop: "-7px" }}>Page {index + 1}</div>
                </div>))}
            
            
            <div className="page">
                <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className='d-flex justify-content-center align-items-center' style={{ height: '500px', width: '300px' }} >
                 <h2>The End</h2>
              </div>
                </Link>
            </div>
            
            
      </HTMLFlipBook>
    </div>
  )
}
